import { configureNextServerRequest } from "@repo/next-utils/next-server-request";
import { getApiUrl } from "@repo/utils/get-api-url";
import { prependUrlWithHttps } from "@repo/utils/prepend-url-with-https";

import { BrowseSearchV2 } from "./types";

export type CategoryParams = {
  requestInstance: ReturnType<typeof configureNextServerRequest>;
  categoryId: number;
  store: string;
  currency: string;
  keyStoreDataversion: string;
  country: string;
  lang: string;
  priceMin?: number;
  priceMax?: number;
  brand?: string;
  colour?: string;
  range?: string;
  size?: string;
  sort?: string;
  limit?: number;
  offset?: number;
  shop: string;
  includeGroups?: string;
  q?: string;
  "tst-search-recs"?: string;
  "tst-search-reciprocalfiltering"?: string;
  "tst-search-campaigns"?: string;
  "tst-search-sponsored-products"?: string;
  "tst-search-advertisements"?: string;
  customerGuid?: string;
  rowLength?: number;
  "key-search-campaign"?: string;
  "key-search-mvtid"?: string;
  region?: string;
  channel?: string;
  excludeFacets?: string;
  advertisementsPartnerId?: string;
  advertisementsOptInConsent?: string;
  advertisementsVisitorId?: string;
  includeNonPurchasableTypes?: string[];
  customerLoyaltyTier?: string;
};

export const getCategoryProducts = async (props: CategoryParams) => {
  const { requestInstance, categoryId, ...searchParams } = props;
  const url = getApiUrl({
    path: `/product/search/v2/categories/${categoryId}/`,
    searchParams,
  });

  try {
    const { data } = await requestInstance.get<BrowseSearchV2>(url, undefined, {
      requestType: "CATEGORIES_API",
    });

    const transformedProducts = data.products.map((product) => ({
      ...product,
      imageUrl: prependUrlWithHttps(product.imageUrl),
      additionalImageUrls:
        product.additionalImageUrls?.map(prependUrlWithHttps) ?? [],
    }));

    return { ...data, products: transformedProducts };
  } catch (error) {
    console.error(error);
    throw error;
  }
};
